var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartCourseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_65_2",
    "data-name": "Component 65 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27205",
    "data-name": "Group 27205"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3758",
    "data-name": "Rectangle 3758",
    width: 24,
    height: 24,
    rx: 2,
    fill: "#2c74bd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14164",
    "data-name": "Path 14164",
    d: "M12.914,7.222l3.1,3.112H5.468v1.734h10.55L12.906,15.18,14.137,16.4l5.2-5.2L14.137,6ZM2,6V16.4H3.734V6Z",
    transform: "translate(1.331 0.799)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartCourseIcon);
export default __webpack_public_path__ + "static/media/start-course-icon.54a35867a42d74234adbf1cc7c76f57c.svg";
export { ForwardRef as ReactComponent };